import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center p-6">

      {/* Logo */}
      <Link
        to="/"
        className="font-heading text-2xl font-bold text-navy hover:opacity-80 transition-opacity mb-12"
      >
        Moment<span className="text-sage">Sent</span>
      </Link>

      {/* Card */}
      <div className="w-full max-w-sm text-center">

        {/* Big 404 */}
        <p
          className="font-heading font-bold leading-none mb-6 select-none"
          style={{ fontSize: '8rem', color: '#d1d5db' }}
          aria-hidden="true"
        >
          404
        </p>

        {/* Heading */}
        <h1 className="font-heading text-2xl text-navy mb-3">
          This page got lost in the mail.
        </h1>

        {/* Subtext */}
        <p className="font-body text-sm text-gray-500 leading-relaxed mb-8">
          The page you're looking for doesn't exist or has moved.
        </p>

        {/* CTA */}
        <Link
          to="/"
          className="btn-primary inline-block px-8 py-3 text-sm"
        >
          Take me home →
        </Link>

      </div>

      {/* Footer micro-copy */}
      <p className="mt-16 font-body text-xs text-gray-400 text-center">
        © {new Date().getFullYear()} MomentSent LLC
      </p>
    </div>
  );
}
